export const zIndex = {
  pageTransitionMask: 30,
  header: 31,
  mobileNav: 32,
  mobileNavButtons: 33,
  cookieBar: 34,
  modal: 36,
}
